import React from "react";
import { Colors } from "./colors";

class DropDown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
      isFocused: false,
      defaultValue: props.value,
    };
  }

  handleFocus = () => {
    this.setState({ isFocused: true });
  };

  handleBlur = () => {
    this.setState({ isFocused: false });
  };

  handleChange = (event) => {
    const { func } = this.props;
    this.setState({ value: event.target.value });
    func(event.target.value);
  };

  render() {
    const { value, isFocused, defaultValue } = this.state;
    const { placeholder, options } = this.props;

    const dropdownStyle = {
      padding: "8px",
      margin: isFocused ? "8px" : "11px",
      width: "105%",
      border: "1px solid #ccc",
      borderRadius: "4px",
      fontSize: "14px",
      outline: "none",
      borderWidth: isFocused ? "4px" : "1px",
      borderColor: isFocused ? Colors.vividBlue : "#ccc",
      transition: "0.1s ease",
      flex: this.props.ratio,
    };
    const optionStyle = {
      transition: "opacity 0.3s ease, height 0.3s ease",
    };

    return (
      <select
        id="dropdown"
        value={value}
        onChange={this.handleChange}
        onFocus={this.handleFocus}
        style={dropdownStyle}
        onBlur={this.handleBlur}
        onKeyDown={this.props.onKeyDown || (() => {})}
      >
        <option value={defaultValue}>
          {defaultValue ? defaultValue : placeholder}
        </option>
        {options.map((option, index) => (
          <option style={optionStyle} key={index} value={option}>
            {option}
          </option>
        ))}
      </select>
    );
  }
}

export default DropDown;
